import { useEffect, useState } from 'react';
import { stompClient } from './stomp-client';
import type { WsState } from './types';

export function useWsSubscription<T>(
  destination: string | null,
  handler: (payload: T) => void,
): void {
  useEffect(() => {
    if (!destination) return;
    const handle = stompClient.subscribe<T>(destination, handler);
    return () => handle.unsubscribe();
  }, [destination, handler]);
}

export function useWsState(): WsState {
  const [state, setState] = useState<WsState>(stompClient.getState());
  useEffect(() => stompClient.onState(setState), []);
  return state;
}
